import { useState } from "react";
import { LegalDocumentModal } from "@/features/legal/components/LegalDocumentModal";
import { PRIVACY_DOCUMENT_KEY } from "@/features/legal/config/legal.config";
import { usePublicLegalDocuments } from "@/features/legal/hooks/usePublicLegalDocuments";
import type { LegalDocument } from "@/features/legal/types/legalCompliance.type";

const LEGACY_PRIVACY_URL = "https://yeati.co/mentions-legales";
const LINK_LABEL = "Politique de confidentialité";

// Opens the privacy notice published by the API, the one frozen with the CGU.
// Falls back to the website page only while nothing is published yet.
export const LoginPrivacyNoticeLink = () => {
  const { data: documents = [] } = usePublicLegalDocuments();
  const [openDocument, setOpenDocument] = useState<LegalDocument | null>(null);
  const privacy = documents.find((document) => document.key === PRIVACY_DOCUMENT_KEY);

  if (!privacy) {
    return (
      <a href={LEGACY_PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="text-primary">{LINK_LABEL}</a>
    );
  }

  return (
    <>
      <button
        type="button"
        className="text-primary underline"
        onClick={() => setOpenDocument(privacy)}
        data-testid="login-privacy-notice-button"
      >
        {LINK_LABEL}
      </button>
      <LegalDocumentModal document={openDocument} onClose={() => setOpenDocument(null)} />
    </>
  );
};

LoginPrivacyNoticeLink.displayName = "LoginPrivacyNoticeLink";
